import { resolveSetup, resolveTheme, themeStyle } from "./setups/registry";
import { useTerminal } from "./useTerminal";

/**
 * The shell.
 *
 * Everything the terminal knows is in `useTerminal()`; everything it looks like
 * is in a setup. This file is the join, and it is deliberately the whole of it —
 * if adding a third look ever needs a change here, the seam has moved to the
 * wrong place and `test/setup-seam.test.tsx` will say so.
 *
 * The root carries three things a setup must not have to remember: the click
 * handler that focuses the prompt, `data-setup`/`data-theme` for screenshots
 * and tests, and the theme's tokens as inline CSS custom properties. Themes are
 * data rather than stylesheets, so adding one touches `setups/registry.ts`
 * alone.
 */
export function Terminal() {
  const model = useTerminal();
  const setup = resolveSetup(model.setupId);
  const theme = resolveTheme(model.themeId);
  const Chrome = setup.Chrome;

  return (
    <div
      className="term-root"
      ref={model.shellRef}
      data-setup={setup.id}
      data-theme={theme.id}
      style={themeStyle(theme)}
    >
      <Chrome model={model} />
    </div>
  );
}
